import { Main } from "../../components";

export const Recibos = () => {
  return (
    <Main>
      <section id="publications" className="services">
        <div className="container padding-top-bottom" data-aos="fade-up">
          <div className="section-title">
            <h2>Recibos</h2>
          </div>

          <div className="row mb-4">
            <div
              className="col-xl-3 col-md-6 d-flex align-items-stretch"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <a
                target="_blank"
                href="https://drive.google.com/file/d/1UxPUgd-5bF1zAO5wIlbv5HaqENKneYfl/view"
                rel="noreferrer"
              >
                <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                  <div className="icon">
                    <img
                      className="pdf-icon"
                      src="/assets/img/pdf-icon.png"
                      alt=""
                    />
                  </div>
                  <h4>Recibo de entrega de escrituração fiscal - 2023</h4>
                </div>
              </a>
            </div>

            <div
              className="col-xl-3 col-md-6 d-flex align-items-stretch"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <a
                target="_blank"
                href="https://drive.google.com/file/d/1P2EENYyrPYS9mhgqaO7p1veKI6AxxeSL/view"
                rel="noreferrer"
              >
                <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                  <div className="icon">
                    <img
                      className="pdf-icon"
                      src="/assets/img/pdf-icon.png"
                      alt=""
                    />
                  </div>
                  <h4>Declaração de escrituração fiscal - 2023</h4>
                </div>
              </a>
            </div>

            <div
              className="col-xl-3 col-md-6 d-flex align-items-stretch"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <a
                target="_blank"
                href="https://drive.google.com/file/d/1BkcXKXH0QcW5FTxx3ZJKHzvI-MmhroM6/view"
                rel="noreferrer"
              >
                <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                  <div className="icon">
                    <img
                      className="pdf-icon"
                      src="/assets/img/pdf-icon.png"
                      alt=""
                    />
                  </div>
                  <h4>Recibo de entrega de escrituração fiscal - 2024</h4>
                </div>
              </a>
            </div>

            <div
              className="col-xl-3 col-md-6 d-flex align-items-stretch"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <a
                target="_blank"
                href="https://drive.google.com/file/d/1BkcXKXH0QcW5FTxx3ZJKHzvI-MmhroM6/view"
                rel="noreferrer"
              >
                <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                  <div className="icon">
                    <img
                      className="pdf-icon"
                      src="/assets/img/pdf-icon.png"
                      alt=""
                    />
                  </div>
                  <h4>Declaração de escrituração fiscal - 2024</h4>
                </div>
              </a>
            </div>            
          </div>
        </div>
      </section>
    </Main>
  );
};
